import styled from 'styled-components'
import { Devices } from '@raysync/common/theme'

export const Title = styled.h2`
  font-size: 36px;
  font-weight: bold;
  color: ${p => p.theme.color.textDarkPlus};
  text-align: center;
  line-height: 1;
  padding-bottom: ${p => (p.pb ? p.pb + 'px' : '0')};
  @media ${Devices.phone} {
    font-size: 0.4rem;
    line-height: 1.2;
  }
`
export const Desc = styled.p`
  color: #636772;
  font-size: 16px;
  line-height: 1.5;
  margin: 20px auto 0;
  max-width: 90%;
  text-align: center;
  p {
    &:not(:first-child) {
      margin-top: 28px;
    }
  }
  @media ${Devices.phone} {
    font-size: 0.2rem;
    max-width: 100%;
    margin-top: 0.3rem;
    p {
      &:not(:first-child) {
        margin-top: 0.28rem;
      }
    }
  }
`
export const SolutionSection = styled.div`
  padding-top: 80px;
  padding-bottom: 100px;
  background: #f5f7fb;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 1rem;
  }
`
export const ArchSection = styled.div`
  padding: 80px 0;
  svg {
    display: block;
    margin: 30px auto 0;
    max-width: 1000px;
  }
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    svg {
      margin-top: 0.3rem;
      max-width: 100%;
    }
  }
`
export const CardsSection = styled.div`
  padding: 80px 0;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }
`
export const MarineSection = styled.div`
  padding: 80px 0 100px;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }
`
export const UseCasesWrapper = styled.div`
  section {
    background-color: #fff;
    @media (min-width: 1400px) {
      div {
        div {
          div {
            width: 264px;
            height: 264px;
            padding-top: 60px;
            svg {
              height: 86px;
            }
          }
        }
      }
    }
  }
`
export const AdvantagesWrapper = styled.div`
  section {
    background: #f5f7fb;
  }
`
export const CasesSection = styled(SolutionSection)``
